import { formatDuration, usePeriod } from '@/lib/time';
import { formatDistanceToNow } from 'date-fns';

export type CountdownTimerProps = {
  time: Date;
  intervalMs?: number;
  format?: (ms: number) => string;
};

export const Timer = (props: CountdownTimerProps) => {
  if (props.time == null) throw new Error('time is null');
  const { time, intervalMs = 1000, format = formatDuration } = props;
  const now = usePeriod(() => new Date(), intervalMs);
  const value = format(now.getTime() - new Date(time).getTime());

  return <>{value}</>;
};

export const CountdownTimer = (props: CountdownTimerProps) => {
  if (props.time == null) throw new Error('time is null');
  const { time, intervalMs = 1000, format = formatDuration } = props;
  const now = usePeriod(() => new Date(), intervalMs);
  const value = format(Math.max(0, time.getTime() - now.getTime()));

  return <>{value}</>;
};

export const TimeFromNow = (props: Pick<CountdownTimerProps, 'time' | 'intervalMs'>) => {
  if (props.time == null) throw new Error('time is null');
  const { time, intervalMs = 1000 } = props;
  const now = usePeriod(() => new Date(), intervalMs); // This runs and updates value below
  const value = formatDistanceToNow(time, { addSuffix: true, includeSeconds: true });

  return <>{value}</>;
};
